export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 27C0 12.09 12.09 0 27 0s27 12.09 27 27-12.09 27-27 27S0 41.91 0 27zm6 0c0 11.58 9.42 21 21 21s21-9.42 21-21S38.58 6 27 6 6 15.42 6 27zm11.13-3.6L24 30.27 36.93 17.4l4.23 4.23-15 15c-.6.57-1.35.87-2.13.87-.78 0-1.53-.27-2.13-.87l-9-9 4.23-4.23z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "54",
    "height": "54",
    "viewBox": "0 0 54 54",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};